import { MeshBasicMaterial, TextureLoader } from "three";
import { type } from "../../types/typeTexture";

export class ManagerLoaderTexture extends TextureLoader {
	constructor(manager) {
		super();
		this.manager = manager;
		this.oneTexture = {};
		this.multipleTexture = [];
	}

	onUploadMeshBasic(url) {
		this.load(
			url,
			(texture) => {
				this.oneTexture = new MeshBasicMaterial({
					map: texture,
				});
			},
			undefined,
			(err) => {
				console.error("An error happened.");
			}
		);
	}

	onUploadMultipleTexture(data = []) {
		data.forEach(({ url, name, position, hover }) => {
			this.load(
				url,
				(texture) => {
					const materialTexture = new MeshBasicMaterial({
						map: texture,
						transparent: true,
					});
					this.multipleTexture.push({ material: materialTexture, name, position, hover });
				},
				undefined,
				(err) => {
					console.error("An error happened.");
				}
			);
		});
	}

	onUploadTexturesViewLocation(data = []) {
		data.forEach(({ name, material, type: typeTexture, position, camarePosition, id, moveHotSpotArrow }) => {
			this.load(
				material,
				(texture) => {
					let materialTexture = null;
					if (typeTexture === type.view360) {
						materialTexture = new MeshBasicMaterial({
							map: texture,
						});
					} else {
						materialTexture = new MeshBasicMaterial({
							map: texture,
							transparent: true,
						});
					}
					this.multipleTexture.push({ material: materialTexture, name, position, typeTexture, camarePosition, id, moveHotSpotArrow });
				},
				undefined,
				(err) => {
					console.error("An error happened.");
				}
			);
		});
	}

	cleanMultipleTexture() {
		this.multipleTexture = [];
	}
}
